export const ROLE_PREFIX = "mcs_roles.promotion.retaileroptin";
export const ROLE_VIEW = ROLE_PREFIX + ".view";
export const ROLE_EDIT = ROLE_PREFIX + ".edit";
export const ROLE_ADD = ROLE_PREFIX + ".add";
export const ROLE_DELETE = ROLE_PREFIX + ".delete";
export const CAN_VIEW = [ROLE_DELETE, ROLE_ADD, ROLE_EDIT, ROLE_VIEW];
export const CAN_EDIT = [ROLE_DELETE, ROLE_ADD, ROLE_EDIT];
export const CAN_CREATE = [ROLE_DELETE, ROLE_ADD];
export const CAN_DELETE = [ROLE_DELETE];
